import * as React from 'react';
import { Row, Col, Label } from 'reactstrap';
import { IChild } from 'src/share/types/case/children';
import { IAbductor } from 'src/share/types/case/abductor';
import PersonImage from './PersonImage';
import { momentToString, momentAgeNow } from 'src/share/utils/utils';

export interface IPersonPosterProps {
  person: IChild | IAbductor
}


export class PersonPoster extends React.Component<IPersonPosterProps> {
  public render() {
    const { images, fullName, birthDate, sex, weight, weightUnit, height, heightUnit, eyeColor, hairColor, } = this.props.person;
    const companionType = (this.props.person as IAbductor).companionType;

    return (
      <div className="personPoster">
        <h3>{companionType ? `Companion: ${fullName}` : fullName}</h3>
        <PersonImage space={'full'} images={images || []} />
        <Row>
          <Col md={6}>
            <p><Label>Birthday:</Label>{birthDate && momentToString(birthDate) || 'unknown'}</p>
            <p><Label>Sex:</Label>{sex}</p>
            <p><Label>Weight:</Label>{`${weight ? !isNaN(weight as any) ? this.twoDecimalsRegex(weight) : weight : 'unknown'} ${weight && weightUnit || ''}`}</p>
            <p><Label>Height:</Label>{`${height ? !isNaN(height as any) ? this.twoDecimalsRegex(height) : height : 'unknown'} ${height && heightUnit || ''}`}</p>
          </Col>
          <Col md={6}>
            <p><Label>Current age:</Label>{birthDate && momentAgeNow(birthDate) || 'unknown'}</p>
            {companionType && <p><Label>Type:</Label>{companionType}</p>}
            {eyeColor && <p><Label>Eye Color:</Label>{eyeColor}</p>}
            {hairColor && <p><Label>Hair Color:</Label>{hairColor}</p>}
          </Col>
        </Row>
      </div>
    );
  }

  public twoDecimalsRegex = (value: string) => {
    const regValue = value.toString().match(/^-?\d+(?:\.\d{0,2})?/);
    return regValue !== null ? regValue.pop() : value;
  }
}
